<template>
  <div class="comp-task" v-if="processedTaskList.length">
    <div @click="data.unfold = !data.unfold" class="hand">
      <jw-space class="stage-header">
        <qfei-icon-caret-down-outlined v-if="data.unfold" class="stage-icon" />
        <qfei-icon-caret-right-outlined v-else class="stage-icon" />

        <span
        >{{ $t('本阶段任务') }} <span v-if="processedTaskList.length">（{{ processedTaskList.length }}）项:</span></span
        >
      </jw-space>
    </div>
    <template v-if="data.unfold">
      <div v-for="(item, index) in processedTaskList" @click="currTaskItem(item, index)" :key="index" class="task-item">
        <div class="task-item-title">
          <div style="display: flex">
            <jw-space v-if="item.status != 0" class="stage-content-underway" style="margin-left: 0">
              <div :style="{ color: getTaskStatus(item.status, 1) }" style="margin-right: 8px">
                <icon-minus-circle style="margin-right: 4px" v-if="item.status == 0" />
                <icon-schedule style="margin-right: 4px" v-if="item.status == 1" />
                <icon-check-circle style="margin-right: 4px" v-if="item.status == 4" />
                <icon-close-circle style="margin-right: 4px" v-if="item.status == 3" />
                <!-- 节点任务应用时的 节点状态0-未完成 1-进行中 3-任务异常 4-已完成 -->
                <span>{{ getTaskStatus(item.status, 2) }}</span>
              </div>
            </jw-space>
            <span class="task-is" v-if="item.required">*</span>
            <div style="display: flex; align-items: center">
              <jw-tooltip v-if="item.name?.length > 20">
                <div class="task-name">{{ item.name }}</div>
                <template #content>
                  <div class="task-name-tooltip">{{ item.name }}</div>
                </template>
              </jw-tooltip>
              <div v-else class="task-name">{{ item.name }}</div>
              <jw-tooltip v-if="item.description">
                <icon-question-circle class="hand" size="16" style="margin-left: 4px; color: var(--color-text-4)" />
                <!-- 这是任务描述  -->
                <template #content>
                  <div class="task-tooltip">{{ item.description }}</div>
                </template>
              </jw-tooltip>
            </div>
          </div>
          <div class="task-primary-title">
            <jw-button type="primary" v-if="checkedStatus(item)" @click="doneTable(item, index)" size="small" style="margin-left: 8px">{{ $t('完成任务') }}</jw-button>
            <p v-if="item.status === 4">任务完成时间：{{ item.gmtUpdated }}</p>
          </div>
        </div>
        <template v-if="[1, 2].includes(item.type)">
          <jw-divider :margin="16" />
          <!-- 多选支持新增多条，单选只支持新增一条 -->
          <template v-if="item.type === 1 && (item.objectMultiple || (!item.objectMultiple && item.businessDataList.length < 1))">
            <div v-if="item.status != 4" class="task-item-content" style="margin-bottom: 16px">
              <div class="task-item-content-value">
                <xl-entity-data-list :multiple="item.objectMultiple" :entity="item.businessData" :taskItem="item" :id="item.businessDataList?.map((mItem) => mItem.businessId)" :isButtom="true" @changeCb="entityDataListChange"></xl-entity-data-list>
              </div>
              <div class="task-item-content-value">
                <jw-button @click="addObjData(item, index)" type="outline" size="small">
                  <template #default>新增数据</template>
                </jw-button>
              </div>
            </div>
          </template>
          <template v-if="item.type == 2">
            <form-data :disabled="item.status === 4" :ref="(el) => setRefs(el, index)" :fieldsList="item.nodeTableFieldVOList?.[0]?.modules || []" :showColumnNum="item.showColumnNum" />
          </template>
        </template>
        <div class="task-item-list">
          <template v-if="Array.isArray(item.businessDataList) && item.businessDataList.length">
            <div class="task-item-list-value" v-for="(mItem, index) in item.businessDataList" :key="index">
              <!-- businessStatus 仅type=1 数据状态 1-正常 2-任务对象已关闭或删除 3-数据删除  entityStatusMessage -->
              <span @click="getDetail(mItem, item)" :class="item.entityStatus !== 1 || mItem.businessStatus == 2 || mItem.businessStatus == 3 ? 'strikethrough' : ''" style="color: rgb(var(--primary-6)); cursor: pointer">{{ mItem.mainFiledValue }}</span>
              <icon-close v-if="item.status !== 4" class="icon-delete" @click.stop="deleteBusniess(mItem.businessId, item)" />
              <!-- 审批状态 2-审批中 3-审批已通过 4-审批未通过 5-审批异常 -->
              <jw-tag :color="getTaskStatus(mItem.approvalStatus, 4)" :size="'small'">{{ getTaskStatus(mItem.approvalStatus, 3) }} </jw-tag>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
  <!--主对象公共详情  S-->
  <ly-detail ref="detailRef"></ly-detail>
  <!-- 弹窗打开 E -->
  <fh-add-edit ref="addEditRef" @cbResult="addCbFun" />
</template>

<script setup>
import { reactive, ref, provide, computed, inject, nextTick } from 'vue';
import { publicService } from '@/api/';
import { Message, Modal } from '@arco-design/web-vue';
import useViewFields from '@/hooks/view-fields';
import FormData from '../form-data/form-data.vue';
import { buildNodeTaskIdsPayload } from '@/hooks/fh-flow-stage-task.mjs';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const { setFieldValue } = useViewFields();
console.log(setFieldValue);
const emits = defineEmits(['cb']);
const props = defineProps({
  node: {
    type: [Object],
    default: () => {}
  },
  taskList: {
    type: [Array],
    default: () => []
  }
});
const formRef = reactive({});
// 存储对应的子组件实例
const setRefs = (el, i) => {
  formRef[`refList_${i}`] = el;
};

const jsonTask = ref(JSON.parse(JSON.stringify(props.taskList)));

// 判断任务完成按钮

/**
 *
    status 0-未完成
    type 3 空任务 可直接完成
    type 2 填写对象数据
    type 1 选择对象数据
 *
 */
const checkedStatus = (taskItem) => {
  if ((taskItem.type === 2 || taskItem.type === 3) && taskItem.status === 0) {
    return true;
  }
  if (taskItem.status === 1) {
    return true;
  }
  return false;
};
const inputList = [0, 1, 7, 11, 13, 16, 21, 23, 26];
const getFormData = (nodeFields) => {
  nodeFields.forEach((n) => {
    (n.type = 20), (n.value = n.setting.fieldKey);

    n.placeholder = inputList.includes(n?.setting?.fieldType) ? t('请输入') : t('请选择');
  });
  const resultModules = setFieldValue([{ modules: nodeFields }], 40);
  return resultModules || [];
};

const processedTaskList = computed(() => {
  return jsonTask.value.map((pItem) => {
    if (pItem.nodeTableFieldVOList?.length) {
      return {
        ...pItem, // 保持其他属性不变
        nodeTableFieldVOList: getFormData(pItem.nodeTableFieldVOList)
      };
    }
    return { ...pItem };
  });
});

const data = reactive({
  unfold: true,
  taskItem: null,
  entityDataListRefIndex: 0,
  form: {}
});

const addEditRef = ref();
const detailRef = ref();
const detailAllFields = inject('detailParams')?.detailAllFields;
const entity = inject('detailParams')?.entity;

//设置当前对象的数据
const setEntityObj = () => {
  const setObjParams = {
    //设置当前对象信息
    label: '',
    value: detailAllFields.value?.id || '',
    fieldKey: '',
    fieldExt: entity.value //当前对象id
  };
  if (entity.value == 1 || entity.value == 101) {
    //线索 线索池
    setObjParams.label = detailAllFields.value?.companyName || '';
  } else if (entity.value == 2) {
    //客户

    setObjParams.label = detailAllFields.value?.customerName || '';
  } else if (entity.value == 3) {
    //商机
    setObjParams.label = detailAllFields.value?.opportunityName || '';
  } else if (entity.value == 4) {
    //产品

    setObjParams.label = detailAllFields.value?.productName || '';
  } else if (entity.value == 6) {
    //报价单

    setObjParams.label = detailAllFields.value?.priceSheetCode || '';
  } else if (entity.value == 8 || entity.value == 10 || entity.value == 13) {
    //合同,订单，退货单

    setObjParams.label = detailAllFields.value?.code || '';
  } else if (entity.value == 12) {
    //售后服务
    setObjParams.label = detailAllFields.value?.salesNo || '';
  } else if (entity.value >= 200) {
    //自定义对象

    setObjParams.label = detailAllFields.value?.name || '';
  }

  return setObjParams;
};

const addObjData = (item, index) => {
  if (item.status == 4) {
    Message.success('任务已完成');
    return;
  }
  if (item.entityStatus == 2) {
    Message.error(item.entityStatusMessage);
    return;
  }
  data.entityDataListRefIndex = index;

  const hasedIds = item.businessDataList?.map((bItem) => bItem.businessId); //当前任务已有的ID集合
  const getEntityObj = setEntityObj();

  const params = { id: '', type: 30, viewId: -1, entity: item.businessData, copy: 0, hasedIds, getEntityObj };
  addEditRef.value?.open(params);
};

const addCbFun = (res) => {
  data.taskItem.businessValue = res;
  console.log('新增的项目', res);
  updateTableValue();
};

const getDetail = (busniessItem, item) => {
  console.log('查看详情', busniessItem, item);
  if (item.entityStatus !== 1) {
    Message.error('数据已失效');
    return;
  }
  if (busniessItem.businessStatus == 2) {
    Message.error(busniessItem.entityStatusMessage);
    return;
  }
  if (busniessItem.businessStatus == 3) {
    Message.error(busniessItem.entityStatusMessage);
    return;
  }
  data.taskItem = item;
  data.taskItem.businessValue = busniessItem.businessId;
  detailRef.value.openDialog();
};

// 修改选择的对象值
const updateTableValue = async () => {
  try {
    const params = {
      id: data.taskItem.id,
      newValue: data.taskItem.businessValue
    };
    const json = await publicService.updateTableValue(params);
    if (!json.error) {
      emits('cb');
    }
  } catch (e) {
    Message.error(e.message || e.statusText || '失败，请重试!');
  }
};

const handleDone = () => {
  Modal.confirm({
    titleAlign: 'start',
    width: 400,
    simple: false,
    title: '完成任务',
    content: '确认完成任务？',
    okText: '确定',
    cancelText: '取消',
    onOk: () => {
      doneTableById();
    }
  });
};

// 完成任务
const doneTable = (item, index) => {
  data.taskItem = item;

  if (item.type === 2) {
    const containerRef = formRef[`refList_${index}`];
    if (containerRef) {
      containerRef.editAddForm.validate((error, value) => {
        console.log('', error, value);
        if (error) {
          const errorMsg = Object.values(error)?.[0]?.message;
          if (errorMsg) Message.error(errorMsg);
          return;
        } else {
          handleDone();
        }
      });
    }
  } else {
    handleDone();
  }
};

// 删除对象数据 当前对象id, 所有已有的id
const deleteBusniess = (bussniessId, allBusniess) => {
  console.log('要删除的对象', bussniessId, allBusniess);
  if (allBusniess.status == 4) {
    Message.warning('任务已完成，不可删除');
    return;
  }
  data.taskItem = allBusniess;
  const resultId = allBusniess.businessDataList?.filter((aItem) => aItem.businessId !== bussniessId)?.map((mItem) => mItem.businessId);
  data.taskItem.businessValue = resultId;
  console.log('要删除的项目', resultId);

  Modal.confirm({
    titleAlign: 'start',
    width: 400,
    simple: false,
    title: '删除对象数据',
    content: '确认删除对象数据？',
    okText: '确定',
    cancelText: '取消',
    onOk: () => {
      updateTableValue();
    }
  });
};

const doneTableById = async () => {
  try {
    const params = {
      id: data.taskItem.id
    };
    const json = await publicService.doneTableById(params);
    if (!json.error) {
      emits('cb');
    } else {
      Message.error(json.error?.msg || '失败!');
    }
  } catch (e) {
    Message.error(e.message || e.statusText || '失败，请重试!');
  }
};
const entityDataListChange = (item = null, mainField = null) => {
  console.log('表格回调', item, mainField);
  // data.taskItem.businessValue = item[0]?.id;
  data.taskItem.businessValue = item?.map((c) => c.id);
  // data.taskItem.mainFiledValue = item[0][mainField];
  data.taskItem.mainFiledValue = item?.map((c) => c.label);

  console.log('开始更新', data.taskItem);
  updateTableValue();
};

const currTaskItem = (item, index) => {
  console.log('绑定');
  data.taskItem = item;
  data.entityDataListRefIndex = index;
};

const getTaskRefIndex = (task) => processedTaskList.value.findIndex((item) => item.id === task?.id);

// 通过任务和渲染索引取到对应的 type=2 子表单容器，避免在父组件里重复推导 ref key。
const getTaskFormContainer = (task) => {
  const currentIndex = getTaskRefIndex(task);
  return formRef[`refList_${currentIndex}`];
};

// 完成节点前只认组件显式暴露的 ready 信号，不再依赖固定轮询次数。
const isTypeTwoTaskFormReady = (task) => Boolean(getTaskFormContainer(task)?.isTaskFormReady?.());

// type=2 任务需要委托子表单做真实校验；只有必做任务才保留可视化错误态。
const validateTypeTwoTask = async (task) => {
  const containerRef = getTaskFormContainer(task);

  if (!containerRef?.validateForNodeComplete || !isTypeTwoTaskFormReady(task)) {
    return {
      pass: false,
      notReady: true,
      message: '任务表单未初始化，请稍后重试'
    };
  }

  return containerRef.validateForNodeComplete({
    showErrors: Boolean(task?.required)
  });
};

// 完成节点前先展开任务区，确保当前可见任务的子表单有机会挂载，再统一生成阻断结果和 nodeTaskIds。
const getNodeCompleteTaskResult = async ({ grayEnabled = false } = {}) => {
  if (!data.unfold) {
    data.unfold = true;
  }

  await nextTick();

  return buildNodeTaskIdsPayload({
    grayEnabled,
    tasks: processedTaskList.value,
    validateTypeTwoTask
  });
};

// 节点任务应用时的 节点状态0-未完成 1-进行中 3-任务异常 4-已完成
const getTaskStatus = (status, type) => {
  // 颜色
  if (type == 1) {
    if (status == 0) {
      // 未完成
      return 'var(--color-text-3)';
    } else if (status == 1) {
      // 进行中
      return 'rgb(var(--orange-5))';
    } else if (status == 3) {
      // 任务异常
      return 'rgb(var(--red-5))';
    } else if (status == 4) {
      // 已完成
      return 'rgb(var(--green-5))';
    }
  }
  // 状态
  if (type == 2) {
    if (status == 0) {
      return '未完成';
    } else if (status == 1) {
      return '进行中';
    } else if (status == 3) {
      return '任务异常';
    } else if (status == 4) {
      return '已完成';
    }
  }
  // 任务列表上的审批状态 仅type=1 ： 审批状态  1-未发起审批 2-审批中 3-审批通过 4-审批拒绝 5-审批异常
  if (type == 3) {
    if (status == 1) {
      return '未发起审批';
    } else if (status == 2) {
      return '审批中';
    } else if (status == 3) {
      return '审批已通过';
    } else if (status == 4) {
      return '审批未通过';
    } else if (status == 5) {
      return '审批异常';
    }
  }
  if (type == 4) {
    if (status == 2) {
      // 审批中
      return 'gold';
    } else if (status == 3) {
      // 审批已通过
      return 'green';
    } else if (status == 4) {
      // 审批未通过
      return 'red';
    } else if (status == 5) {
      // 审批异常
      return 'red';
    }
  }
};

provide('globalParams', {
  id: computed(() => data.taskItem?.businessValue),
  entity: computed(() => data.taskItem?.businessData),
  viewId: -1
});

defineExpose({
  getNodeCompleteTaskResult
});
</script>
<style scoped lang="less">
@import './task.less';
</style>
